import { wavesboxLoader } from '../../rankers/components/wavesbox/wavesbox_loader';
wavesboxLoader();
